import type { FIXED_INDENTS } from 'vars/index'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { MEDIA } from 'vars/index'

export const PlayerGeoblockSC = styled.div<{
  gap: FIXED_INDENTS
  isSmallPlayer: boolean
}>`
  position: absolute;
  top: ${({ isSmallPlayer }) => (isSmallPlayer ? '50%' : '50vh')};
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${({ gap }) => `var(${gap})`};

  --small-player-max-width: 290px;
  --large-player-max-width: 340px;

  ${MEDIA.MIN_600} {
    --large-player-max-width: 480px;
  }

  ${MEDIA.MIN_1240} {
    --small-player-max-width: 340px;
  }

  ${MEDIA.MIN_1640} {
    --large-player-max-width: 530px;
  }

  ${TextBoxSC} {
    max-width: ${({ isSmallPlayer }) =>
      isSmallPlayer
        ? 'var(--small-player-max-width)'
        : 'var(--large-player-max-width)'};
  }
`
